<template>
  <div class="container">
    <div v-if="selectedCompetition">
      <header class="jumbotron">
        <h1>Deltakere</h1>
        <div>
          ({{content.participants && content.participants.length}} deltakere)
        </div>
      </header>
      <div class="list row">
        <div class="col-md-6">
          <ul class="list-group">
            <li class="list-group-item"
              :class="{ active: index == currentIndex }"
              v-for="(participant, index) in content.participants"
              :key="index"
              @click="setActiveParticipant(participant, index)"
            >
            <div :style="{ backgroundColor: (!participant.email && !participant.email2) ? 'yellow' : '' }">
              {{ participant.participant_bib }} - {{ participant.participant_name }} <small hidden="hidden">(Id:{{ participant.participant_id }})</small> - {{ participant.participant_team }} 
            <!-- <a class="badge badge-success float-right"
              :href="'/mod/competition/'+ selectedCompetition ? selectedCompetition.id : '' +'/participant/' + participant.participant_id"
            > 
              Vis utøver
            </a> -->
            <router-link class="badge badge-success float-right"
              :to="{ name: 'participant_moderator', params: { competition_id: selectedCompetition ? selectedCompetition.id : 'TODO', participant_id: participant.participant_id}}">Vis utøver</router-link>
            </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="alert alert-danger" role="alert">
        <h4>Velg stevne</h4>
        <p>Du må velge et stevne for å se deltakere.</p>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '../services/user.service';
import MyComputed from '../myComputed';

export default {
  mixins: [MyComputed],
  name: 'Participants',
  data() {
    return {
      content: '',
      currentParticipant: null,
      currentIndex: -1,
      debug: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      console.log("BoardParticipants getData");
      console.log("this.$route.params.competition_id: "+this.$route.params.competition_id);
      var competition_id = this.$route.params.competition_id;
      if (competition_id && !this.selectedCompetition) {
        console.log("competition_id && !this.selectedCompetition");
        await this.$store.dispatch('competition/setSelectedCompetitionId', competition_id);
      }  
      UserService.getParticipantsBoard(competition_id).then(
        response => {
          this.content = response.data;
        },
        error => {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    setActiveParticipant(participant, index) {
      this.currentParticipant = participant;
      this.currentIndex = index;
    }
  },
};
</script>
